// extracted by mini-css-extract-plugin
export default {"heading":"login_heading__mwSwi","wrapper":"login_wrapper__YZ3FB","container":"login_container__LFrgh","box":"login_box__dhUBb","text":"login_text__WsmD6","link":"login_link__j6O3h"};